import { all, put, takeLatest } from 'redux-saga/effects';
import { forgotPasswordActions as actions } from '.';

import httpclient from 'libs/Axios/index';
import { PayloadAction } from '@reduxjs/toolkit';

import History from 'core/utils/history';
import { VerifyOTPRequest } from './types';
import jwtDecode from 'jwt-decode';

function* verifyUser(
  action: PayloadAction<{ data: { USER_NAME: string, SRC: string; }; cancelToken: any }>,
) {
  const { USER_NAME, SRC } = action.payload.data;
  try {
    const response = yield httpclient().post(
      '/auth/resetPassword',
      { USER_NAME, SRC },
      {
        cancelToken: action.payload?.cancelToken?.token || false,
      },
    );
    const data = response?.data?.data;

    let info: any = '';

    if (data?.token) {
      info = jwtDecode(data?.token);
      yield put(actions.verifyUsernameSuccess(info));
    } else {
      yield put(actions.verifyUsernameSuccess(data));
    }
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.verifyUsernameFailure(errorDetails));
  }
}

function* verifyOTP(
  action: PayloadAction<{ data: VerifyOTPRequest; cancelToken: any }>,
) {
  const { USER_ID, USER_NAME, OTP, TOKEN } = action.payload.data;
  try {
    const response = yield httpclient().post(
      '/auth/resetPassword/verify/otp',
      { USER_ID, USER_NAME, OTP, TOKEN },
      {
        cancelToken: action.payload?.cancelToken?.token || false,
      },
    );
    const data = response?.data?.data;
    yield put(actions.clearState());
    yield put(actions.verifyOTPSuccess(data));
    History.navigate(`/reset-password?__user_id=${USER_ID}&__token=${encodeURIComponent(data?.token)}`);
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.verifyOTPFailure(errorDetails));
  }
}

function* resetPassword(
  action: PayloadAction<{
    data: { USER_ID: number; NEW_PASSWORD: string };
    token: string;
    cancelToken: any;
  }>,
) {
  try {
    const response = yield httpclient({token: `Bearer ${action?.payload?.token}`}).put(
      '/auth/updatePassword',
      action.payload.data,
      {
        cancelToken: action.payload?.cancelToken?.token || false,
      },
    );
    const data = response?.data?.data;
    History.navigate(`/login?__resetPassword=1`);

    yield put(actions.resetPasswordSuccess(data));
  } catch (error: any) {
    const errorDetails = error?.response?.message || error?.message;
    yield put(actions.resetPasswordFailure(errorDetails));
  }
}

export function* forgotPasswordSaga() {
  yield all([
    takeLatest(actions.verifyUsernameStart.type, verifyUser),
    takeLatest(actions.verifyOTPStart.type, verifyOTP),
    takeLatest(actions.resetPasswordStart.type, resetPassword),
  ]);
}
